import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { useLocation } from "@/location/hooks/useLocation";
import { AddressWrapper } from "./AddressWrapper";
export const Address = ({ isLink, showIcon = true, fontSize = "16", }) => {
    const { address } = useLocation() || {};
    if (!address)
        return null;
    const { street, district, city, zipCode } = address;
    const cityZipGroup = city || zipCode ? (_jsxs("span", { style: { whiteSpace: "nowrap" }, children: [city, zipCode && ` (${zipCode})`] })) : null;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { paddingVertical: "spacing.8", children: _jsxs(AddressWrapper, { isLink: isLink, showIcon: showIcon, fontSize: fontSize, textAlign: "left", children: [street && _jsxs(_Fragment, { children: [street, ",\u00A0"] }), district && _jsxs(_Fragment, { children: [district, ",\u00A0"] }), cityZipGroup] }) }), isLink && (_jsx(Divider, { "aria-hidden": "true", marginVertical: "spacing.24" }))] }));
};
